import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaEye } from "react-icons/fa";
import AdvanceSearch from "../AdvanceSearch/AdvanceSearch";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io";
import { authorizedGet } from "../../Config/networkWithToken";
import { authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import { Link } from "react-router-dom";
import { MdCancel } from "react-icons/md";
import MessageBar, {
  config,
  DOBASEURL,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../utils/helper";
import Spinner from "../Spinner/Spinner";
import RejectModel from "../RejectModel/RejectModel";

const UserActive = () => {
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const [users, setUsers] = useState([]);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [rejectUserId, setRejectUserId] = useState(null);
  const [rejectVerifyId, setRejectVerifyId] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [rejectedUsers, setrejectedUsers] = useState([]);
  const [category, setCategory] = useState("");

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const fetchActiveUser = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getAllUserVerifyRequests}?adminId=${adminId}`,
        config,
      );
      const responseStatus = res?.data;
      if (responseStatus?.status) {
        const response = responseStatus?.data;
        setUsers(response);
        let pending = [];
        let reject = [];

        response.forEach((value) => {
          if (value?.isRejected) {
            reject.push(value);
          } else {
            pending.push(value);
          }
        });

        setPendingUsers(pending);
        setrejectedUsers(reject);
      }
    } catch (err) {}
    setLoading(false);
  };

  const userActive = async (userId, userVerifyId, status, comment = "") => {
    setLoading(true);
    try {
      const data = {
        adminId: adminId,
        userId: userId,
        userVerifyId: userVerifyId,
        status: status,
        comments: comment,
        category: category,
      };

      const res = await authorizedPost(
        configuration.apis.userVerifyApproval,
        data,
        config,
      );

      const responseStatus = res?.data;
      if (responseStatus?.status) {
        successNotify(res?.data?.message);
        const response = responseStatus?.data;
        let pending = [];
        let reject = [];

        response.forEach((value) => {
          if (value?.isRejected) {
            reject.push(value);
          } else {
            pending.push(value);
          }
        });

        setPendingUsers(pending);
        setrejectedUsers(reject);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchActiveUser();
  }, [adminId]);

  const handleAdvanceSearch = (searchValue) => {
    setSearchQuery(searchValue.toLowerCase());
  };

  const toggleSearchBar = () => {
    setShowAdvanceSearch((prev) => !prev);
    setSearchQuery("");
  };

  const openCommentSection = (userId, userVerifyId) => {
    setRejectUserId(userId);
    setRejectVerifyId(userVerifyId);
    setIsCommentSectionOpen(true);
  };

  const closeModal = () => {
    setComment("");
    setIsCommentSectionOpen(false);
    setCategory("");
    setError(false);
  };

  const handleNoteChange = (e) => {
    setComment(e.target.value);
    setError(false);
  };

  const handleSaveComment = () => {
    if ((!comment || comment.length < 15) && !category) {
      setError(true);
    } else {
      userActive(rejectUserId, rejectVerifyId, "reject", comment);
      closeModal();
    }
  };

  const getFilteredUsers = (tabIndex = null) => {
    const baseList =
      tabIndex === null
        ? activeTab === 0
          ? pendingUsers
          : rejectedUsers
        : tabIndex === 0
          ? pendingUsers
          : rejectedUsers;

    const filteredList = baseList
      .filter((user) => user?.name?.toLowerCase()?.includes(searchQuery))
      .filter((user) => {
        const today = new Date();
        const registerDate = new Date(user?.sentAt);

        if (filter === "today") {
          return (
            registerDate.getDate() === today.getDate() &&
            registerDate.getMonth() === today.getMonth() &&
            registerDate.getFullYear() === today.getFullYear()
          );
        }

        const diffTime = Math.abs(today - registerDate);
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (filter === "week") return diffDays < 7;
        if (filter === "month")
          return registerDate.getMonth() === today.getMonth();
        if (filter === "year")
          return registerDate.getFullYear() === today.getFullYear();
        return true;
      });

    return tabIndex === null ? filteredList : filteredList.length;
  };

  const tabList = [
    { name: "Pending Users", count: getFilteredUsers(0) },
    { name: "Rejected Users", count: getFilteredUsers(1) },
  ];

  return (
    <div className="p-4 sm:p-6">
      {loading ? (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
            {/* <h2 className="text-lg font-semibold text-gray-800 sm:text-xl md:text-2xl">
          Activate Users{" "}
          <span className="text-[20px] font-normal text-gray-500">
            ({filteredUsers.length})
          </span>
        </h2> */}
            <div className="flex w-full flex-col justify-between border-b border-gray-300  md:flex-row">
              <ul className="flex flex-col justify-center md:flex-row">
                {tabList.map((list, index) => (
                  <li
                    key={index}
                    className={`mt-3 cursor-pointer px-4 py-2 text-center text-textGreen transition-all ${showAdvanceSearch ? "text-[13px] xl:text-[16px]" : "sm:text-xs md:text-base"} 
                    ${
                      activeTab === index
                        ? "border-b-2 border-textYellow text-textYellow "
                        : "hover:bg-gray-100 hover:text-textYellow"
                    }`}
                    onClick={() => handleTabClick(index)}
                  >
                    {list.name}({list.count})
                  </li>
                ))}
              </ul>

              <div className="flex items-center gap-3">
                {/* Search Icon & Advanced Search */}
                <div className="flex items-center gap-2">
                  {!showAdvanceSearch ? (
                    <IoIosSearch
                      className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                      onClick={toggleSearchBar}
                    />
                  ) : (
                    <div className="flex items-center gap-2">
                      <AdvanceSearch onSearchValue={handleAdvanceSearch} />
                      <ImCancelCircle
                        className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                        onClick={toggleSearchBar}
                      />
                    </div>
                  )}
                </div>

                {/* Filter Dropdown */}
                <div className="flex items-center gap-2">
                  <p className="text-sm text-gray-700 sm:text-base">Sort by:</p>
                  <select
                    className="rounded-md border px-2 py-1 text-sm sm:px-3 sm:py-2 sm:text-base"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {getFilteredUsers().length === 0 ? (
            <div className="text-center text-lg text-gray-500">
              No users found
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
              {getFilteredUsers().map((user) => (
                <div
                  key={user?.id}
                  className="rounded-xl border bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md"
                >
                  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                    <div className="flex justify-center sm:justify-start">
                      <img
                        src={
                          user?.photos?.length > 0
                            ? DOBASEURL + user?.photos?.[0]
                            : user?.photos
                        }
                        alt={user?.name}
                        className="h-30 w-30 rounded-lg border border-gray-300 sm:h-32 sm:w-32"
                      />
                    </div>
                    <div className="flex flex-col justify-start text-left sm:col-span-2 sm:text-left">
                      <h3 className="text-base font-semibold sm:text-lg md:text-xl">
                        {user?.name?.length
                          ? user?.name?.slice(0, 18) +
                            (user?.name.length > 15 ? "..." : "")
                          : "NA"}
                      </h3>

                      <p className="text-sm text-gray-600 sm:text-base">
                        {user?.gender}
                      </p>
                      <p className="text-sm text-gray-600 sm:text-base">
                        {user?.maritalStatus}
                      </p>
                      <p className="text-sm text-gray-600 sm:text-base">
                        {user?.primaryEmail?.length
                          ? user?.primaryEmail?.slice(0, 20) +
                            (user?.primaryEmail.length > 20 ? "..." : "")
                          : "NA"}
                      </p>
                      <p className="text-xs text-gray-500 sm:text-sm">
                        Registered on:{" "}
                        <span className="font-normal">
                          {user?.createdAt
                            ? new Date(user.createdAt).toLocaleDateString(
                                "en-GB",
                              )
                            : "N/A"}
                        </span>
                      </p>
                      <p className="text-xs text-gray-500 sm:text-sm">
                        Sent at:{" "}
                        <span className="font-normal">
                          {user?.sentAt
                            ? new Date(user.sentAt).toLocaleDateString("en-GB")
                            : "N/A"}
                        </span>
                      </p>
                    </div>
                  </div>
                  {activeTab === 1 && user?.rejectedComment && (
                    <div className="mt-2 text-sm text-gray-700 sm:text-base">
                      <p>
                        <span className="font-semibold text-red-600">
                          Rejected At:
                        </span>{" "}
                        {user?.rejectedAt
                          ? new Date(user.rejectedAt).toLocaleDateString(
                              "en-GB",
                            )
                          : "N/A"}
                      </p>
                      <p>
                        <span className="font-semibold text-red-600">
                          Rejected By:
                        </span>{" "}
                        {user?.rejectedBy || "N/A"}
                      </p>
                      <p className="font-semibold text-red-600">
                        Rejection Comment:
                      </p>
                      <p className="line-clamp-2 overflow-hidden text-ellipsis break-words">
                        {user?.rejectedComment}
                      </p>
                    </div>
                  )}

                  <div className="mt-4 flex flex-col items-center gap-2 sm:gap-4">
                    {/* Show Activate & Reject buttons only in Pending tab (activeTab === 0) */}
                    {activeTab === 0 && (
                      <div className="flex w-full flex-row justify-center gap-2 sm:gap-4">
                        <button
                          onClick={() =>
                            userActive(user?.userId, user?.id, "approve")
                          }
                          className="flex w-full items-center justify-center gap-2 rounded-md bg-green-500 px-3 py-2 text-xs text-white transition-colors duration-200 hover:bg-green-600 sm:w-auto sm:text-sm md:text-base"
                        >
                          <FaCheckCircle size={16} /> Activate
                        </button>

                        <button
                          onClick={() =>
                            openCommentSection(user?.userId, user?.id)
                          }
                          className="flex w-full items-center justify-center gap-2 rounded-md bg-red-500 px-3 py-2 text-xs text-white transition-colors duration-200 hover:bg-red-600 sm:w-auto sm:text-sm md:text-base"
                        >
                          <MdCancel size={18} /> Reject
                        </button>
                      </div>
                    )}

                    <div className="flex w-full justify-center">
                      <Link
                        to={`/user-active/viewProfile/${user?.userId}`}
                        className="w-full sm:w-auto"
                      >
                        <button className="flex w-full items-center justify-center gap-2 rounded-md bg-yellow-500 px-14 py-2 text-xs text-white transition-colors duration-200 hover:bg-yellow-600 sm:w-auto sm:text-sm md:text-base">
                          <FaEye size={16} /> View Profile
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {isCommentSectionOpen && (
            <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
              <RejectModel
                setComment={setComment}
                comment={comment}
                handleNoteChange={handleNoteChange}
                closeModal={closeModal}
                error={error}
                handleSaveComment={handleSaveComment}
                setCategory={setCategory}
                category={category}
                isShowDropdown={false}
              />
            </div>
          )}
        </>
      )}
      <MessageBar />
    </div>
  );
};

export default UserActive;
